import { STATIC_BASE_URI } from '../configs';

export const getStaticFileUrl = (path: string) => `${STATIC_BASE_URI}/${path}`;
